export default __webpack_public_path__ + "static/media/NicVanDenBroeck.394e043e.png";